import { render, staticRenderFns } from "./DocNetwork.vue?vue&type=template&id=a3f2b68a&scoped=true&"
import script from "./DocNetwork.vue?vue&type=script&lang=js&"
export * from "./DocNetwork.vue?vue&type=script&lang=js&"
import style0 from "./DocNetwork.vue?vue&type=style&index=0&id=a3f2b68a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f2b68a",
  null
  
)

export default component.exports